import type { TEntityType } from '@/components/entity-detail/types/EntityType.types';
import type { RouteManagerInterface } from '@/utils/route/routeManager';
import type { Entity } from './entity';
import { AssigneeEntity } from './factories/assignee';
import { BusinessTripFormEntity } from './factories/business_trip_form';
import { CustomerEntity } from './factories/customer';
import { DeviceEntity } from './factories/device';
import { RatingEntity } from './factories/rating';
import { ReminderScheduleEntity } from './factories/reminder_schedule';
import { TaskEntity } from './factories/task';
import { TicketEntity } from './factories/ticket';

export class EntityTypeManager {
    public routeManager: RouteManagerInterface;

    public constructor(routeManager: RouteManagerInterface) {
        this.routeManager = routeManager;
    }

    public create(type: TEntityType): null | Entity {
        switch (type) {
            case 'TICKET':
                return new TicketEntity(this.routeManager);

            case 'CUSTOMER':
                return new CustomerEntity(this.routeManager);

            case 'DEVICE':
                return new DeviceEntity(this.routeManager);

            case 'ASSIGNEE':
                return new AssigneeEntity(this.routeManager);

            case 'TASK':
                return new TaskEntity(this.routeManager);

            case 'BUSINESS_TRIP_FORM':
                return new BusinessTripFormEntity(this.routeManager);

            case 'REMINDER_SCHEDULE':
                return new ReminderScheduleEntity(this.routeManager);

            case 'RATING':
                return new RatingEntity(this.routeManager);

            default:
                console.error(`Invalid entity type: ${type}`);

                return null;
        }
    }
}
